export enum DuRoleEnum {
  OWNER = 'OWNER',
  DELEGATE = 'DELEGATE',
}
